import React from 'react'
import CardArtiste from '../CardArtiste/CardArtiste'


const MapArtist = (props) => {

    return (
        <>
                {props.MesCards.slice(0).reverse().map(item => (
                    
                    <CardArtiste className="col-sm-3 col-xs-12"
                        id={item.id}
                        NameArtist={item.NameArtist}
                        NameURL={item.NameURL}
                        imgProfilRond={item.imgProfilRond} 
                        CategorieArtiste={item.CategorieArtiste} 
                        imgbg={item.imgbg} 
                        link={item.link} 
                        
                    />
                ))}
        </>
    )
}

export default MapArtist
